import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { addOnlineForm } from 'actions';
import { connect } from 'react-redux';

const MatchedForm = ({ dispatch, matchedFormId }) => {
  const openMatchedForm = () => dispatch(addOnlineForm(matchedFormId, { id: 1 }));

  useEffect(() => {
    const lastCard = document.getElementById('finalMatchedForm');
    if (window && lastCard && lastCard.offsetTop) {
      window.scrollTo({ top: lastCard.offsetTop - 100 });
    }
  }, []);

  return (
    <div id="finalMatchedForm" className="question-card matched-form">
      <p className="question-title"><strong><FormattedMessage id="preQualifyingQuestionnaire.matchedForm.title" /></strong></p>
      <p><FormattedMessage id="preQualifyingQuestionnaire.matchedForm.mainText" /></p>
      <button className="btn questionnaire-button continue" type="button" onClick={ openMatchedForm }>Continue</button>
    </div>
  );
};

MatchedForm.propTypes = {
  matchedFormId: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapDispatchToProps
)(MatchedForm);
